import { PAGE_TYPE } from "@faire/deprecated-retailer-visitor-shared/consts/PAGE_TYPE";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import * as React from "react";

export interface LayoutElementRendererData {
  layoutElement: ILayoutElement;
  requestId: string;
  onItemClick?: (
    containerName: string,
    requestId: string,
    token: string
  ) => void;
  onCTAClick?: (containerName: string, requestId: string) => void;
  onVisible?: (
    containerName: string,
    requestId: string,
    tokens: string
  ) => void;
  pageType?: PAGE_TYPE;
}

export namespace LayoutElementRendererData {
  export const build = (
    partial?: Partial<LayoutElementRendererData> | undefined
  ): LayoutElementRendererData => ({
    layoutElement: ILayoutElement.build(partial?.layoutElement),
    requestId: partial?.requestId ?? "",
    onItemClick: partial?.onItemClick,
    onCTAClick: partial?.onCTAClick,
    onVisible: partial?.onVisible,
    pageType: partial?.pageType,
  });
}

export const Context = React.createContext<LayoutElementRendererData>(
  LayoutElementRendererData.build()
);

export const LayoutElementProvider: React.FC<
  React.PropsWithChildren<LayoutElementRendererData>
> = (props) => {
  return <Context.Provider value={props}>{props.children}</Context.Provider>;
};
